import { State } from '../../reducers'

export const getIsSubmittingJob = ({ ui }: State) => ui.job.isSubmitting
